import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/", //首页
        name: "index",
        component: (resolve) => require(['@/views/home/index.vue'], resolve)
    },
    {
        path: "/game", //游戏落地页
        name: "game",
        component: (resolve) => require(['@/views/LandingPage/game.vue'], resolve)
    },
    {
        path: "/app", //APP盒子落地页
        name: "app",
        component: (resolve) => require(['@/views/LandingPage/app.vue'], resolve)
    },
    {
        path: "/wcjq", //王朝崛起007
        name: "wcjq",
        component: (resolve) => require(['@/views/LoadingPageGameS/WangChaoJueQi.vue'], resolve)
    },
    {
        path: "/rxcs", //热血传说857
        name: "rxcs",
        component: (resolve) => require(['@/views/LoadingPageGameS/ReXueChuanShuo.vue'], resolve)
    }
]

let router = new VueRouter({
    // base: '/dist',
    mode: 'history',
    disableDotRule: true,
    routes
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js